import { RoundedCornerSize } from "../enums";
import { LayoutOptionData } from "../interfaces";

export function getRoundedClass(size?: RoundedCornerSize): string {
    switch (size) {
        case RoundedCornerSize.Small:  return 'rounded-sm';
        case RoundedCornerSize.Medium: return 'rounded-lg';
        case RoundedCornerSize.Large:  return 'rounded-2xl';
        case RoundedCornerSize.Full:   return 'rounded-full';
        case RoundedCornerSize.None:
        default:       return '';
    }
}

/**
 * Computes inline styles for each layout entry based on its options and the
 * current viewport mode. When `pageFullWidth` is enabled on desktop, the
 * section breaks out of the max-w-6xl container to span the full viewport.
 * On mobile, sections are already full-width so no breakout is needed.
 */
export function computeLayoutStyles(layoutOrder: LayoutOptionData[] | undefined, isMobile: boolean | null): void {
    if (!layoutOrder) {
        return;
    }
    layoutOrder.forEach(layout => {
        const styles: { [key: string]: string } = {};

        if (isMobile) {
            styles.width = layout.mobileWidthPercentage || '100%';
            styles['margin-top'] = `${layout.mobileTopMargin}px`;
            styles['margin-bottom'] = `${layout.mobileBottomMargin}px`;
            styles['margin-left'] = 'auto';
            styles['margin-right'] = 'auto';
        } else if (layout.pageFullWidth) {
            // Full-bleed: break out of the max-w-6xl container to span full viewport width
            styles.width = '100vw';
            styles['margin-top'] = `${layout.topMargin}px`;
            styles['margin-bottom'] = `${layout.bottomMargin}px`;
            styles['margin-left'] = 'calc(50% - 50vw)';
            styles['margin-right'] = 'calc(50% - 50vw)';
            if (layout.sectionMaxHeight && layout.sectionMaxHeight !== 'none') {
                styles['max-height'] = layout.sectionMaxHeight;
            }
        } else {
            styles.width = layout.widthPercentage || '100%';
            styles['margin-top'] = `${layout.topMargin}px`;
            styles['margin-bottom'] = `${layout.bottomMargin}px`;
            styles['margin-left'] = 'auto';
            styles['margin-right'] = 'auto';
        }
        layout.styles = styles;
    });
}
